import type { z } from 'zod';
import { defaultZodErrorParser, type ZodErrorParser } from './defaultZodErrorParser';
import { type ErrorContext, normalizeErrorMessage } from './errorType';

export const validateSchema = <T, S extends z.ZodType<T>>(
  schema: S,
  context: ErrorContext<S>,
  customZodErrorParser?: ZodErrorParser,
) => {
  return (params: z.input<S>): z.output<S> => {
    const parsedResult = schema.safeParse(params);
    const errorParser = customZodErrorParser || defaultZodErrorParser;

    if (!parsedResult.success) {
      const parsedErrors = parsedResult.error ? errorParser(parsedResult.error) : [];
      const errorMessage = normalizeErrorMessage(context, parsedErrors.join('\n'));
      throw new Error(errorMessage);
    }

    return parsedResult.data;
  };
};
